type SubjectListItem = {
    id?: number
    gradeId?: number
}

export const isSubjectGradeAlreadyUsed = (list: SubjectListItem[], gradeId: number) => {
    return list.some((item) => item.id && item.gradeId === gradeId)
}
